import { useEffect, useState } from 'react'
import type { Sizes } from '@wellesley/uploads'
import { Crop } from 'react-image-crop'
import getCropSettings from '../helpers/getCropSettings'

type HookProps = {
  aspect?: number
  sizes?: Sizes
  imgMaxHeight?: number
}

const useCropSettings = ({ aspect = 1, sizes, imgMaxHeight }: HookProps) => {
  const [crop, setCrop] = useState<Crop>()

  useEffect(() => {
    const canSet = sizes?.width && sizes.height && imgMaxHeight

    canSet && setCrop(getCropSettings(sizes, aspect, imgMaxHeight))
  }, [sizes?.height, sizes?.width, imgMaxHeight, aspect])

  return [crop, setCrop] as const
}

export default useCropSettings
